import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

function RevealText({ text, bgColor, fgColor, forward }) {
  const textRef = useRef(null);

  useEffect(() => {
    const char = textRef.current;

    // Split the text into characters
    const textSplit = new SplitType(char, { types: "chars" });

    if (forward) {
      // GSAP animation for each character
      gsap.fromTo(
        textSplit.chars,
        { color: bgColor },
        {
          color: fgColor,
          duration: 0.3,
          stagger: 0.02,
          scrollTrigger: {
            trigger: char,
            start: "top 80%",
            end: "top 20%",
            scrub: true,
            markers: false,
            toggleActions: "play play reverse reverse",
          },
        }
      );
    } else {
      gsap.fromTo(
        textSplit.chars,
        { color: fgColor }, // Start with fgColor
        {
          color: bgColor, // Change to bgColor on scroll
          duration: 0.3,
          stagger: 0.02,
          scrollTrigger: {
            trigger: char,
            start: "top 80%",
            end: "top 20%",
            scrub: true,
            markers: false,
            toggleActions: "play play reverse reverse",
          },
        }
      );
    }

    // Cleanup: Revert SplitType changes on unmount
    return () => {
      textSplit.revert();
    };
  }, [bgColor, fgColor, forward]);

  return (
    <p ref={textRef} className="reveal-type">
      {text}
    </p>
  );
}

export default RevealText;
